<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"
    
    :data-type="context.type"
  >
    <input class=""  type="text" readonly disabled
            :value="getInputValue"
            v-bind="context.attributes"
            @blur="context.blurHandler"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    noteToExcessOptions: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
        
    }
  },
  watch: {
    model () {
    },
  },
  computed: {
    model () {
      return this.context.model
    },
    getInputValue(){
        
        const chosen_excess = this.answers[this.getStep('quote')].vehicle_excess ?? this.answers[this.getStep('quote')].vehicle_excess_third_party;
        const target = this.noteToExcessOptions.find(element => element.value.toString() == chosen_excess);

        if( target ){
            return target.label;
        } else {
            return '';
        }
    },
    ...mapGetters({ answers: 'flattenedAnswers', getStep: 'getStep' }),
  },
  methods: {
  },
}
</script>

<style>

</style>